import type { TranslateService } from '@ngx-translate/core';
import type { OnyxOptional } from '@onyx/angular';
import { isArray } from 'lodash';
import type { DictionaryCode } from '../../../common/enums/dictionary-code';

export class ExportHelper {
  public static mapField<T extends string | string[]>(
    value: OnyxOptional<T>,
    dictionaryCode: DictionaryCode,
    ...args: T extends string[] ? [TranslateService] : []
  ): string {
    const [translateService] = args;

    if (value == null) return '';

    const formatValue = (value: string): string => {
      if (!dictionaryCode) return value;
      return `${dictionaryCode}.${value}`;
    };

    if (isArray(value)) {
      return value
        .map((value) => formatValue(value))
        .map((value) => translateService?.instant(value) ?? value)
        .join(', ');
    }

    return formatValue(value);
  }
}
